import { render, staticRenderFns } from "./channels-tab.vue?vue&type=template&id=12f83230"
import script from "./channels-tab.vue?vue&type=script&lang=js"
export * from "./channels-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports